import {
  ADM, SDM, SDMX, SDMPRO,
  SY, WL, HDA4, HDA5, HDA6, HDA7,
  HDA8,
} from '@/utils/constants';

const menus = [
  {
    label: '阵列位移计',
    id: ADM,
    submenus: [
      { label: '采集记录', subPath: 'adm-collections' },
      { label: '变形分量图', subPath: 'adm-chart', needSuper: true },
      { label: '变形三维图', subPath: 'profiles-3d' },
      { label: '变形剖面图', subPath: 'profiles' },
      { label: '变形方位图', subPath: 'coordinates', needSuper: true },
      { label: '设备状态表', subPath: 'state' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '倾角计',
    id: SDM,
    submenus: [
      { label: '采集记录', subPath: 'sdm-collections' },
      { label: '变形分量图', subPath: 'sdm-chart' },
      { label: '组网测量', path: 'cluster-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '振动计',
    id: SDMX,
    submenus: [
      { label: '采集记录', subPath: 'sdmx-collections' },
      { label: '振动历史图', subPath: 'sdmx-chart' },
      { label: '振动实时图', subPath: 'sdmx-real-time-chart' },
      { label: '变形分量图', subPath: 'sdm-chart' },
      { label: '测点信息表', path: 'pointInfo' },

    ],
  },
  {
    label: '倾角振动计',
    id: SDMPRO,
    submenus: [
      { label: '采集记录', subPath: 'sdmpro-collections' },
      { label: '倾角监测图', subPath: 'sdmpro-tilt-chart' },
      { label: '振动监测图', subPath: 'sdmpro-vibr-chart' },
      { label: '组网测量', path: 'cluster-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '振弦式渗压计',
    id: SY,
    submenus: [
      { label: '采集记录', subPath: 'hda2-collections' },
      { label: '数据分量图', subPath: 'hda2-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '电流式水位计',
    id: WL,
    submenus: [
      { label: '采集记录', subPath: 'hda3-collections' },
      { label: '数据分量图', subPath: 'hda3-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '振弦式测缝计',
    id: HDA4,
    submenus: [
      { label: '采集记录', subPath: 'hda4-collections' },
      { label: '数据分量图', subPath: 'hda4-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '锚索应力计',
    id: HDA5,
    submenus: [
      { label: '采集记录', subPath: 'hda5-collections' },
      { label: '数据分量图', subPath: 'hda5-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '振弦式钢筋计',
    id: HDA6,
    submenus: [
      { label: '采集记录', subPath: 'hda6-collections' },
      { label: '数据分量图', subPath: 'hda6-chart' },
      { label: '测点信息表', path: 'pointInfo' },
    ],
  },
  {
    label: '振弦式应变计',
    id: HDA7,
    submenus: [
      { label: '采集记录', subPath: 'hda7-collections' },
      { label: '数据分量图', subPath: 'hda7-chart' },
    ],
  },
  {
    label: '振弦式轴力计',
    id: HDA8,
    submenus: [
      { label: '采集记录', subPath: 'hda8-collections' },
      { label: '数据分量图', subPath: 'hda8-chart' },
    ],
  },
];

if (window.location.host.match(/localhost|t4sd/)) {
  menus[0].submenus.push({ label: '隧道收敛图', path: 'tunnels' });
}


export default menus;

const map = new Map();
menus.forEach((item) => {
  item.submenus.forEach((row) => {
    map.set(row.subPath, row.label);
  });
});

export const menuMap = map;

